// Copyright © Veeam Software Group GmbH

// TODO: when backend adds missing properties to models, delete it
export const findIdValueInUrl = (url: string, idName: string) =>
    url.split('/').find((element, index, array) => array[index - 1] === idName && element);
